import Component from '@glimmer/component';
import { PrismIcon, PrismTooltipHeader } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import changeColorClass from 'lumen/helpers/change-color-class';

interface GeneralTooltipsTooltipBulletChartSignature {
  Args: {
    data: {
      difference: number;
      formattedCurrent: string;
      formattedDifference: string;
      formattedReference: string;
      isReferenceMissing: boolean;
      labelCurrentValue: string;
      labelReferenceValue: string;
    };
    invertDifferenceColor: boolean;
    title: string;
  };
}

export default class GeneralTooltipsTooltipBulletChart extends Component<GeneralTooltipsTooltipBulletChartSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get differenceTypeIcon() {
    if (this.args.data.difference === 0) {
      return null;
    }

    if (this.args.invertDifferenceColor) {
      return this.args.data.difference > 0
        ? ({ name: 'arrow-down', color: 'critical' } as const)
        : ({ name: 'arrow-up', color: 'success' } as const);
    }

    return this.args.data.difference > 0
      ? ({ name: 'arrow-up', color: 'success' } as const)
      : ({ name: 'arrow-down', color: 'critical' } as const);
  }

  <template>
    <div class="bullet-chart-tooltip-container">
      <PrismTooltipHeader>
        <span class="block px-200">{{@title}}</span>
      </PrismTooltipHeader>

      <div class="flex justify-center">
        <div class="bullet-chart-box flex items-center justify-center">
          <div class="value">
            <div class="flex items-center gap-100">
              <div class="identifier-square bg-traffic-light-neutral"></div>
              <p class="text-400--bold">
                {{@data.formattedCurrent}}
              </p>
            </div>
            <p class="label text-200--regular">{{@data.labelCurrentValue}}</p>
          </div>

          <div class="value">
            <div class="flex items-center gap-100">
              <div class="identifier-square bg-data-bar"></div>
              <p class="text-400--bold">
                {{#if @data.isReferenceMissing}}
                  {{t "general.missing"}}
                {{else}}
                  {{@data.formattedReference}}
                {{/if}}
              </p>
            </div>
            <p class="label text-200--regular">{{@data.labelReferenceValue}}</p>
          </div>

          <div class="value">
            <div class="flex items-center">
              <p
                class="{{changeColorClass
                    @data.difference
                    invertColors=@invertDifferenceColor
                  }}
                  text-400--bold"
              >
                {{#if @data.isReferenceMissing}}
                  {{t "general.missing"}}
                {{else}}
                  {{@data.formattedDifference}}
                {{/if}}
              </p>
              {{#if this.differenceTypeIcon}}
                <PrismIcon
                  @color={{this.differenceTypeIcon.color}}
                  @name={{this.differenceTypeIcon.name}}
                  @size="small"
                />
              {{/if}}
            </div>
            <p class="label text-200--regular">{{t "general.difference"}}</p>
          </div>

        </div>
      </div>
    </div>
  </template>
}
